<template>
    <!-- Main viewer container -->
    <div class="viewer-container">
        <!-- Content container -->
        <div id="container">
            <!-- Swiper slideshow - zero spacing between slides and single slide view -->
            <swiper :slides-per-view="1" :space-between="0" @swiper="onSwiper" @slideChange="onSlideChange">
                <!-- Slide 1: Remove glasses step -->
                <swiper-slide>
                    <div class="step">
                        <!-- Step image -->
                        <div class="image">
                            <div :style="`background-image: url(${getStepImage(1)})`"></div>
                        </div>
                        <!-- Step title -->
                        <div class="title">Gözlükleri çıkarın</div>
                        <!-- Step description -->
                        <div class="desc">Aksi halde tuhaf görünecek, bize inanın.</div>
                        <!-- Forward/back navigation arrows -->
                        <div class="arrows">
                            <div class="prev" @click="back('list')">
                                <img :src="ASSETS.IMAGES.ARROW_PREV" />
                            </div>
                            <div @click="nextStep" class="next">
                                <img :src="ASSETS.IMAGES.ARROW_NEXT" />
                            </div>
                        </div>
                        <!-- Progress indicator -->
                        <div class="progress-container">
                            <div class="current">{{currentStep}}</div>
                            <div class="progress-steps">
                                <div v-for="step in 5" :key="step" :class="['progress-step', { 'active': step <= currentStep }]"></div>
                            </div>
                            <div>{{totalSteps}}</div>
                        </div>
                        <!-- Logo -->
                        <div class="logo"><img :src="ASSETS.IMAGES.LOGO" /></div>
                    </div>
                </swiper-slide>

                <!-- Slide 2: Hair preparation step -->
                <swiper-slide>
                    <div class="step">
                        <div class="image">
                            <div :style="`background-image: url(${getStepImage(2)})`"></div>
                        </div>
                        <div class="title">Saçınızı toplayın</div>
                        <div class="desc">Yüzünüzün saçlarla kaplı olmadığından emin olun.</div>
                        <div class="arrows">
                            <div @click="prevStep" class="prev">
                                <img :src="ASSETS.IMAGES.ARROW_PREV" />
                            </div>
                            <div @click="nextStep" class="next">
                                <img :src="ASSETS.IMAGES.ARROW_NEXT" />
                            </div>
                        </div>
                        <div class="progress-container">
                            <div class="current">{{currentStep}}</div>
                            <div class="progress-steps">
                                <div v-for="step in 5" :key="step" :class="['progress-step', { 'active': step <= currentStep }]"></div>
                            </div>
                            <div>{{totalSteps}}</div>
                        </div>
                        <div class="logo"><img :src="ASSETS.IMAGES.LOGO" /></div>
                    </div>
                </swiper-slide>

                <!-- Slide 3: Lighting step -->
                <swiper-slide>
                    <div class="step">
                        <div class="image">
                            <div :style="`background-image: url(${getStepImage(3)})`"></div>
                        </div>
                        <div class="title">İyi Aydınlatma Sağlayın</div>
                        <div class="desc">Yüzünüzdeki gölgelerden kaçının. Bir pencerenin önünde durun.</div>
                        <div class="arrows">
                            <div @click="prevStep" class="prev">
                                <img :src="ASSETS.IMAGES.ARROW_PREV" />
                            </div>
                            <div @click="nextStep" class="next">
                                <img :src="ASSETS.IMAGES.ARROW_NEXT" />
                            </div>
                        </div>
                        <div class="progress-container">
                            <div class="current">{{currentStep}}</div>
                            <div class="progress-steps">
                                <div v-for="step in 5" :key="step" :class="['progress-step', { 'active': step <= currentStep }]"></div>
                            </div>
                            <div>{{totalSteps}}</div>
                        </div>
                        <div class="logo"><img :src="ASSETS.IMAGES.LOGO" /></div>
                    </div>
                </swiper-slide>

                <!-- Slide 4: Camera position step -->
                <swiper-slide>
                    <div class="step">
                        <div class="image">
                            <div :style="`background-image: url(${getStepImage(4)})`"></div>
                        </div>
                        <div class="title">Doğrudan kameraya bakın</div>
                        <div class="desc">Akıllı telefonu başınızın hizasında tutun, aşağıda değil.</div>
                        <div class="arrows">
                            <div @click="prevStep" class="prev">
                                <img :src="ASSETS.IMAGES.ARROW_PREV" />
                            </div>
                            <div @click="nextStep" class="next">
                                <img :src="ASSETS.IMAGES.ARROW_NEXT" />
                            </div>
                        </div>
                        <div class="progress-container">
                            <div class="current">{{currentStep}}</div>
                            <div class="progress-steps">
                                <div v-for="step in 5" :key="step" :class="['progress-step', { 'active': step <= currentStep }]"></div>
                            </div>
                            <div>{{totalSteps}}</div>
                        </div>
                        <div class="logo"><img :src="ASSETS.IMAGES.LOGO" /></div>
                    </div>
                </swiper-slide>

                <!-- Slide 5: Photo taking instructions step -->
                <swiper-slide>
                    <div class="step">
                        <div class="image">
                            <div :style="`background-image: url(${getStepImage(5)})`"></div>
                        </div>
                        <div class="title">3 fotoğraf çekmeniz gerekecek</div>
                        <div class="desc">Ön, sol ve sağ taraf olacak şekilde.</div>
                        <div class="arrows">
                            <div @click="prevStep" class="prev">
                                <img :src="ASSETS.IMAGES.ARROW_PREV" />
                            </div>
                            <div @click="nextStep" class="take-image">
                                <div>Tara</div>
                            </div>
                        </div>
                        <div class="progress-container">
                            <div class="current">{{currentStep}}</div>
                            <div class="progress-steps">
                                <div v-for="step in 5" :key="step" :class="['progress-step', { 'active': step <= currentStep }]"></div>
                            </div>
                            <div class="current">{{totalSteps}}</div>
                        </div>
                        <div class="logo"><img :src="ASSETS.IMAGES.LOGO" /></div>
                    </div>
                </swiper-slide>

                <!-- Slide 6: Gender selection step -->
                <swiper-slide>
                    <div class="step">
                        <div class="image">
                            <div :style="`background-image: url(${gender_url})`"></div>
                        </div>
                        <div class="flex-wrapper">
                            <div class="title" @click="gender = 'erkek'" :class="gender !== 'erkek' ? 'not' : ''">Erkek</div>
                            <div class="title" @click="gender = 'kadın'" :class="gender !== 'kadın' ? 'not' : ''">Kadın</div>
                        </div>
                        <div class="desc">Vücut tipini seçiniz.</div>
                        <div class="arrows solo">
                            <div @click="lastStep" class="next">
                                <img :src="ASSETS.IMAGES.ARROW_NEXT" />
                            </div>
                        </div>
                        <div class="logo right"><img :src="ASSETS.IMAGES.LOGO" /></div>
                    </div>
                </swiper-slide>

                <!-- Slide 7: Camera component -->
                <swiper-slide>
                    <CameraComponent :gender="gender" :info="initStep" :completed="completed" :uid="uid" v-if="currentStep === 7" />
                </swiper-slide>
            </swiper>
            <!-- Skip button - not shown in the final step -->
            <div class="skip" v-if="currentStep !== 7" @click="imageStep">Atla</div>
        </div>
    </div>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import CameraComponent from '@/components/CameraComponent.vue'
// Import Swiper styles
import 'swiper/css';
import { ASSETS } from '@/constants/urls';
import { getFormStepImage } from '@/constants/pathUtils';

/**
 * CreateAvatarForm
 * 
 * Multi-step form component for avatar creation process
 * Guides users through preparation steps before taking photos
 * 
 * @component
 */
export default {
    name: 'CreateAvatarForm',
    props: {
        /** User ID */
        uid: String,
        /** Callback function when form is completed */
        completed: Function,
        /** Function for navigating back */
        goBack: Function
    },
    components: {
        Swiper,
        SwiperSlide,
        CameraComponent
    },
    data() {
        return {
            /** Swiper configuration options */
            swiperOptions: {
                slidesPerView: 1,
                loop: false,
            },
            /** Current step number */
            currentStep: 1,
            /** Total number of steps */
            totalSteps: 5,
            /** Swiper instance */
            swiper: null,
            /** Selected gender (male/female) */
            gender: 'kadın',
            /** Form data for each step */
            formData: {
                step1Data: {},
                step2Data: {},
                step3Data: {},
                step4Data: {},
                step5Data: {},
            },
            /** Asset constants for template usage */
            ASSETS
        };
    },
    computed: {
        /**
         * Get gender-specific image URL
         * @returns {string} URL for the gender image
         */
        gender_url() {
            return this.gender === 'erkek' ? ASSETS.IMAGES.FORM.MALE : ASSETS.IMAGES.FORM.FEMALE;
        }
    },
    methods: {
        /**
         * Get image for a specific step
         * @param {number} stepNumber - The step number
         * @returns {string} URL for the step image
         */
        getStepImage(stepNumber) {
            return getFormStepImage(stepNumber);
        },
        
        /**
         * Navigate back to specified page
         * @param {string} str - Page identifier
         */
        back(str) {
            this.goBack(str);
        },
        
        /**
         * Go to last step (camera step)
         */
        lastStep() {
            this.currentStep = 7;
            const lastIndex = this.swiper.slides.length - 1;
            this.swiper.slideTo(lastIndex);
        },
        
        /**
         * Go to gender selection step
         */
        imageStep() {
            this.currentStep = 6;
            const lastIndex = this.swiper.slides.length - 2;
            this.swiper.slideTo(lastIndex);
        },
        
        /**
         * Return to first step
         */
        initStep() {
            this.currentStep = 1;
            this.swiper.slideTo(0);
        },
        
        /**
         * Save swiper instance reference
         * @param {Object} swiper - Swiper instance
         */
        onSwiper(swiper) {
            console.log('swiper', swiper);
            this.swiper = swiper;
        },
        
        /**
         * Handle slide change event
         */
        onSlideChange() {
            console.log('slide change');
        },
        
        /**
         * Go to next step
         */
        nextStep() {
            this.swiper.slideNext();
            this.currentStep++;
        },
        
        /**
         * Go to previous step
         */
        prevStep() {
            this.swiper.slidePrev();
            this.currentStep--;
        }
    }
}
</script>

<style scoped>
.take-image {
    background: #ABABAB;
    border-radius: 18px;
    color: #fff;
    line-height: 2;
    margin-right: 20px;
    cursor: pointer;
}

.logo img {
    max-width: 90px;
}

.viewer-container,
.swiper-container {
    height: 100%;
}

.title {
    font-size: 32px;
    font-weight: 500;
    padding: 10px 0;
    max-width: 80%;
    text-align: center;
    cursor: pointer;
}

.desc {
    font-size: 15px;
    font-weight: 200;
    padding: 0;
}

.step {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100% - 80px);
    padding: 60px 0 20px 0;
}

.step div {
    color: #f7f7f7;
}

.arrows {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.arrows.solo {
    display: flex;
    justify-content: center;
    width: 100%;
}

.arrows>div {
    padding: 0 20px;
}

.arrows img {
    width: 30px;
}

.swiper {
    height: 100%;
}

.image,
.desc {
    flex: 1;
}

.image>div {
    width: 250px;
    height: 250px;
    margin-bottom: 20px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.progress-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    width: 120px;
    gap: 10px;
}

.progress-steps {
    display: flex;
    width: 100%;
    max-width: 500px;
    overflow: hidden;
    border-radius: 5px;
}

.progress-step {
    flex-grow: 1;
    height: 5px;
    background-color: #e0e0e0;
    margin: 0;
}

.progress-step:first-child {
    margin-left: 0;
}

.progress-step:last-child {
    margin-right: 0;
}

.progress-container .current {
    color: #4caf50;
}

.progress-step.active {
    background-color: #4caf50;
}

.skip {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #f7f7f7;
    font-size: 14px;
    cursor: pointer;
    z-index: 2;
}

.flex-wrapper {
    display: flex;
    gap: 20px;
}

.title.not {
    color: #ABABAB;
}
</style>